<template>
  <div class="layouts-container">
    <Header />
    <div class="banner">
      <div class="banner-title">
        <!-- <h1>第九工场-设计服务</h1>
            <p>坚持做<span style="">『</span>吸引眼球，价格厚道』的好设计</p> -->
        <img :src="`${ossBaseUrl}/top_word.png`" style="width: 600px; height: 130px" />
      </div>
      <div class="todowns">
        <img :src="`${ossBaseUrl}/icon_down.png`" />
      </div>
      <div class="images" :style="{backgroundImage: `url(${ossBaseUrl}/swipe.jpg)`}"></div>
      <div class="overlay"></div>
    </div>
    <div class="teamwork">
      <h2>
        <img :src="`${ossBaseUrl}/icon27.jpg`" alt="" />合作优势<img
          :src="`${ossBaseUrl}/icon28.jpg`"
          alt=""
        />
      </h2>
      <h3>第九工场已服务过500多家优质企业，涵盖30多个行业</h3>
      <h3>与数家大型公司长期合作，锻造了一支能应对各类需求的设计团队</h3>
      <table class="table1">
        <tr style="transform: translateX(30px)">
          <td>
            <img
              :src="`${ossBaseUrl}/ui1.png`"
              style="
                width: 270px;
                height: 245px;
                position: relative;
                top: -5px;
                left: 25px;
              "
              alt=""
            />
            <p style="position: relative; top: -13px; left: 16px">平面设计</p>
          </td>
          <td>
            <img
              :src="`${ossBaseUrl}/ui2.png`"
              style="width: 190px; height: 216px; left: -5px"
              alt=""
            />
            <p>视频制作</p>
          </td>
          <td>
            <img
              :src="`${ossBaseUrl}/ui3.png`"
              style="width: 225px; height: 215px; left: -10px"
              alt=""
            />
            <p>程序开发</p>
          </td>
          <td>
            <img
              :src="`${ossBaseUrl}/ui4.png`"
              style="width: 190px; height: 224px; left: -10px"
              alt=""
            />
            <p>插画绘制</p>
          </td>
          <td style="transform: translateX(-60px)">
            <img
              :src="`${ossBaseUrl}/ui5.png`"
              style="width: 335px; height: 226px; left: 20px"
              alt=""
            />
            <p>文案撰写</p>
          </td>
        </tr>
      </table>
      <table class="teamwork-more">
        <tr>
          <td>
            <img class="icon" :src="`${ossBaseUrl}/ui6.jpg`" alt="" />
            <h4>合作无忧</h4>
            <p>草图不满意，可全额退款</p>
            <p>三年售后，免费微调</p>
          </td>
          <td>
            <img class="img02" :src="`${ossBaseUrl}/ui9.jpg`" alt="" />
            <img
              class="icon"
              :src="`${ossBaseUrl}/ui7.jpg`"
              style="margin-left: -50px"
              alt=""
            />
            <h4>品质保障</h4>
            <p>严格把控流程和品质</p>
            <p>超预期交付</p>
          </td>
          <td>
            <img class="icon" :src="`${ossBaseUrl}/ui8.jpg`" alt="" />
            <h4>商用无忧</h4>
            <p>坚持原创</p>
            <p>无版权风险</p>
          </td>
        </tr>
      </table>
    </div>
    <div class="design">
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />特色设计<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>

      <div class="switch">
        <div
          class="tab"
          :class="{ active: itemIndex == item.index }"
          v-for="(item, index) in featureTab"
          :key="index"
          @click="switchFeatureTab(item.index)"
        >
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div class="tabImg">
        <img
          style="width: 100%; height: 100%"
          v-show="itemIndex == 1"
          :src="`${ossBaseUrl}/tab.png`"
        />
        <img
          style="width: 100%; height: 100%"
          v-show="itemIndex == 2"
          :src="`${ossBaseUrl}/swipe.png`"
        />
      </div>
      <div class="more"><a href="https://909th.com/works">了解更多</a></div>
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />热门设计<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>

      <div class="hot">
        <div>
          <div
            class="tabHot"
            :class="{ activeHot: hotIndex == item.index }"
            v-for="(item, index) in hotTab"
            :key="index"
            @click="switchHotTab(item.index)"
          >
            <div>{{ item.title }}</div>
          </div>
        </div>
        <div class="rightContent">
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 1"
            :src="`${ossBaseUrl}/tab1.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 2"
            :src="`${ossBaseUrl}/tab2.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 3"
            :src="`${ossBaseUrl}/tab3.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 4"
            :src="`${ossBaseUrl}/tab4.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 5"
            :src="`${ossBaseUrl}/tab5.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 6"
            :src="`${ossBaseUrl}/tab6.jpg`"
          />
          <img
            style="width: 100%; height: 100%"
            v-show="hotIndex == 7"
            :src="`${ossBaseUrl}/tab7.jpg`"
          />
        </div>
      </div>
      <div class="more"><a href="https://909th.com/works">了解更多</a></div>
    </div>
    <div class="morelink">
      <div class="morelink-link">
        <h3>已服务过<span>500</span>多家大型企业</h3>
        <img :src="`${ossBaseUrl}/logos.png`" style="width: 100%" />
        <!-- <table>
                <tr>
                    <td><img :src="`${ossBaseUrl}/icon1.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon2.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon3.jpg`" style="width: 159px;height: 25px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon4.jpg`" style="width: 140px;height: 50px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon5.jpg`" style="width: 159px;height: 30px;" alt=""></td>
                </tr>
                <tr>
                    <td><img :src="`${ossBaseUrl}/icon6.jpg`" style="width: 159px;height: 42px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon7.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon8.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon9.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon10.jpg`" style="width: 159px;height: 30px;" alt=""></td>
                </tr>
                <tr>
                    <td><img :src="`${ossBaseUrl}/icon11.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon12.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon13.jpg`" style="width: 149px;height: 50px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon14.jpg`" style="width: 149px;height: 40px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon15.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                </tr>
                <tr>
                    <td><img :src="`${ossBaseUrl}/icon16.jpg`" style="width: 170px;height: 55px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon17.jpg`" style="width: 149px;height: 55px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon18.jpg`" style="width: 159px;height: 45px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon19.jpg`" style="width: 165px;height: 40px;" alt=""></td>
                    <td><img :src="`${ossBaseUrl}/icon20.jpg`" style="width: 195px;height: 30px;" alt=""></td>
                </tr>
            </table> -->
      </div>
    </div>
    <div class="process">
      <h2>
        <img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_left.png`"
          alt=""
        />合作流程<img
          class="greendot"
          :src="`${ossBaseUrl}/greendot_right.png`"
          alt=""
        />
      </h2>
      <table>
        <tr>
          <td>
            <img
              :src="`${ossBaseUrl}/icon21.png`"
              style="width: auto; height: 100px"
              alt=""
            />
            <h3>填需求表</h3>
            <h3>协商细节</h3>
          </td>
          <td class="td02">
            <img
              :src="`${ossBaseUrl}/arrow_green.png`"
              style="width: 25px; height: 25px; left: -76px; top: 58px"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon22.png`"
              style="width: auto; height: 100px; margin-left: -17px"
              alt=""
            />
            <h3>签订协议</h3>
            <h3>预付70%费用</h3>
          </td>
          <td>
            <img
              :src="`${ossBaseUrl}/arrow_dark.png`"
              style="width: 25px; height: 25px; left: -82px; top: 58px"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon23.png`"
              style="width: auto; height: 100px; margin-left: -17px"
              alt=""
            />
            <h3>验收草图</h3>
            <h3>反馈意见</h3>
          </td>
          <td class="td02">
            <img
              :src="`${ossBaseUrl}/arrow_green.png`"
              style="width: 25px; height: 25px; left: -73px; top: 58px"
              alt=""
            />
            <img
              :src="`${ossBaseUrl}/icon24.png`"
              style="width: auto; height: 100px; margin-left: -17px"
              alt=""
            />
            <h3>验收终稿</h3>
            <h3>支付尾款</h3>
          </td>
        </tr>
      </table>
    </div>
    <div class="connect">
      <div class="links_items">
        <div class="lefts">
          <div>
            <h2>沟通无障碍-认真接待每位咨询者</h2>
            <p>支持电话、微信、视频会议等沟通方式</p>
          </div>
          <div class="items">
            <div class="qrText">了解合作细节</div>
            <div class="qrText right">
              请扫右侧二维码
              <img :src="`${ossBaseUrl}/arrow.png`" alt="" />
            </div>
          </div>
        </div>
        <div class="rights">
          <div class="">
            <!-- connectRight -->
            <img
              :src="`${ossBaseUrl}/qrcode.png`"
              style="width: 200px; height: 200px"
              alt=""
            />
          </div>
          <text class="textAdd">欢迎扫码添加好友咨询</text>
        </div>
      </div>

      <!-- <div class="connectLeft">
		   <div class="connectTop">
		       <h2>沟通无障碍-认真接待每位咨询者</h2>
		       <p>支持电话、微信、视频会议等沟通方式</p>
		   </div>
		   <div class="items">
			  <div class="qrText ">了解合作细节</div>
			  <div class="qrText right">请扫左侧二维码
			   <img :src="`${ossBaseUrl}/arrow.png`" alt="">
			  </div>
		   </div>

        </div>
        <div>
            <div class="connectRight">
				<img :src="`${ossBaseUrl}/qrcode.png`" style="width: 200px;height: 200px;" alt="">
			</div>
            <text class="connectRight textAdd">欢迎扫码添加好友咨询</text>
        </div> -->
      <div class="connectBottom" style="">
        <div style="margin-top: 10px; line-height: 60px">
          <div>
            <img
              :src="`${ossBaseUrl}/icon30.jpg`"
              style="
                width: 50px;
                height: 35px;
                vertical-align: middle;
                margin-right: 20px;
              "
              alt=""
            />
            <span style="font-size: 25px">18061610919</span>
          </div>
          <div>
            <img
              :src="`${ossBaseUrl}/icon31.jpg`"
              alt=""
              style="
                width: 55px;
                height: 30px;
                vertical-align: middle;
                margin-right: 12px;
              "
            />
            <span style="font-size: 25px">koala@909th.com</span>
          </div>
          <!-- zzhou@9thws.com -->
        </div>
        <div class="connectBg">
          <img :src="`${ossBaseUrl}/illus_bottom.png`" style="" /><!-- bg.jpg -->
        </div>
      </div>
    </div>

    <div class="qr">
      <div
        class="close_box"
        style="position: absolute; top: 1px; right: 5px"
        @click="toggleKefu"
      >
        <img :src="`${ossBaseUrl}/close.png`" style="width: 20px; height: 20px" />
      </div>
      <div class="kefu_box" v-if="show_kefu == true">
        <div>
          <img :src="`${ossBaseUrl}/kefu_bg.png`" style="width: 190px; height: 320px" />
        </div>
        <!-- <div class="add" style="position:relative;top:-270px">
				<div><span class="txt1">微信扫码</span><span class="txt2">添加好友</span></div>
				<div><span class="txt1">设计顾问</span><span class="txt2">为您服务</span></div>
			</div> -->
        <!-- <div class="qrImg"></div> -->
        <div class="name" style="position: relative; top: -96px">
          第九工场-考拉
        </div>
        <div
          style="
            position: relative;
            top: -102px;
            font-size: 16px;
            margin-left: 64px;
            font-weight: 520;
            color: #805e4e;
          "
        >
          商务经理
        </div>
        <!-- class="position" -->
      </div>
    </div>

    <div class="foot_bar">
      <div class="titles">
        来不及找到心仪的内容? 按<span class="btn">Ctrl</span>+<span class="btn"
          >D</span
        >收藏我们
      </div>
    </div>

    <div class="foot_box">
      <div class="foot_link">
        <div class="lefts">
          <div class="title" style="font-size: 14px">关于我们</div>
          <div style="font-size: 12px">
            第九工场上线于2015年,
            从最初单一的艺术二维码模板交易平台发展至今成为：艺术二维码模板交易、设计定制服务、
          </div>
          <div style="font-size: 12px">设计交易培训为一体的设计机构</div>
        </div>
        <div class="qrcodes">
          <div class="qr1">
            <img :src="`${ossBaseUrl}s/footer/qrcode.png`" />
            <div class="txt">关注我, 学技巧</div>
          </div>
          <div class="qr2">
            <img :src="`${ossBaseUrl}s/footer/qrcode_99.png`" />
            <div class="txt">有问题, 找九九</div>
          </div>
        </div>
      </div>
      <div
        style="
          padding-left: 360px;
          width: 1170px;
          margin: 0 auto;
          padding: 20px 20px 0px 76px;
        "
      >
        <hr align="left" width="1000" color="#59DDDC" SIZE="1" style="margin: 0; width: 100%" />
      </div>
      <div class="copyrights">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备15061928号-4 版权所有：南京良码信息科技有限公司</a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {ossBaseUrl} from "@/main";
export default {
  components: {
    Header,
  },
  data() {
    return {
      ossBaseUrl,
      show_kefu: true,
      hotIndex: 1,
      itemIndex: 1,
      featureTab: [
        { index: 1, title: "艺术二维码设计" },
        { index: 2, title: "设计师远程包月" },
      ],
      hotTab: [
        { index: 1, title: "商业插画" },
        { index: 2, title: "卡通形象" },
        { index: 3, title: "海报设计" },
        { index: 4, title: "界面设计" },
        { index: 5, title: "视频制作" },
        { index: 6, title: "文章排版" },
        { index: 7, title: "三维设计" },
      ],
      keyObj: { Control: -1, d: -1 },
    };
  },
  mouted() {
    document.onkeydown = (e) => {
      // ctrl   keyCode ==> 17  |  D  d keyCode ==> 68
      // 用户按下 ctrl 17
      const { keyCode } = e;
      // console.log('keyCode ===>', keyCode);
      if (keyCode === 17) {
        this.keyObj.Control = 17;
      } else if (keyCode === 68 && this.keyObj.Control === 17) {
        this.keyObj.d = 68;
      }
    };
    document.onkeyup = (e) => {
      const { keyCode } = e;
      if (keyCode === 17) {
        this.keyObj = { Control: -1, d: -1 };
      }
    };
  },
  watch: {
    keyObj: {
      handler: function (obj) {
        this.ctrl$dHandler(obj);
      },
      deep: true,
    },
  },
  methods: {
    ctrl$dHandler(obj) {
      const { Control, d } = obj;
      if (Control === 17 && d === 68) {
        // alert('用户按下了 ctrl + d, #######')
        console.log("用户按下了 ctrl + d, #######");
      }
    },
    toggleKefu() {
      this.show_kefu = !this.show_kefu;
    },
    switchHotTab(index) {
      this.hotIndex = index;
    },
    switchFeatureTab(index) {
      this.itemIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.layouts-container {
  width: 100%; /* min-width: 1280px; */
}
.banner {
  position: relative;
  overflow: hidden;
  height: 838px;
}
.banner-title {
  position: absolute;
  text-align: center;
  top: 40%;
  width: 100%; /* left: 36%; */
  z-index: 99;
  margin: 0 auto;
}
.banner-title h1 {
  color: #76d3cf;
  font-size: 80px;
  line-height: 50px;
}
.banner-title p {
  color: #f2f2f2;
  font-size: 36px;
}
.todowns {
  position: absolute;
  text-align: center;
  top: 85%;
  width: 100%;
  z-index: 99; /* left: 49%; */
}
.todowns img {
  width: 30px;
  height: 20px;
  cursor: pointer;
}
.overlay {
  position: relative;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.images {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 300%;
  animation: banner 40s linear infinite;
  background-size: auto 100%;
}
@keyframes banner {
  0% {
    left: 0;
  }
  100% {
    left: -200%;
  }
}
.greendot {
  width: 80px;
  height: 15px;
}

.textAdd {
  font-size: 20px;
  margin-top: 10px;
  text-align: center;
  color: #fff;
  background-color: #0d282c !important;
}
.position {
  margin-left: 50px;
  text-align: center;
  width: 100px;
  font-size: 16px;
  font-weight: 520;
  border-radius: 20px;
  padding: 5px;
  background-image: linear-gradient(to right, #f2dec9, #dfbe9f);
  /* color: #fff; */
}
.name {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  font-size: 16px;
  margin-top: 10px;
}
.add {
  margin-top: 10px;
  width: 150px;
  text-align: center;
  margin-left: calc(50% - 75px);
  font-size: 16px;
}
.add .txt1 {
  color: #b09a8c;
}
.add .txt2 {
  color: #dbbca3;
}
.hello {
  margin-top: 10px;
  text-align: center;
  color: #76d3cf;
  font-size: 24px;
  font-weight: 700;
}
.qrImg {
  margin-top: 10px;
  margin-left: calc(50% - 50px);
  width: 100px;
  height: 100px;
  background-color: #fff;
}
.weightText {
  margin-bottom: 50px !important;
}
.text {
  margin-top: 10px;
  line-height: 80px;
  color: #fff;
  font-size: 24px;
}
.right {
  position: relative;
  margin-left: -80px;
  text-align: center !important;
  color: #000 !important;
  background-color: #fff !important;
}

.qrText {
  padding-left: 20px;
  border-radius: 80px;
  font-weight: 800;
  width: 250px;
  font-size: 20px;
  line-height: 60px;
  color: #fff;
  text-align: left;
  border: 1px solid #eee;
  background-color: #0d282c;
}
.qrText.right > img {
  width: 23px;
  height: 22px;
  margin-left: 5px;
  margin-top: -4px;
  vertical-align: middle;
}
.connectTop {
  position: absolute;
  top: 110px;
  left: 10%;
  width: 670px;
  height: 130px;
}
.connectTop h2 {
  font-size: 34px;
  color: #76d3cf;
  line-height: 40px;
}
.connectTop p {
  font-size: 27px;
  color: #f2f2f2;
}

.connectLeft {
  margin: 270px 155px; /*left: 10%;  margin-left: calc(50% - 520px); */
}
.connectLeft .items {
  display: flex;
  width: 500px;
  height: 60px;
}

.connectRight {
  margin-left: 350px;
  margin-top: 120px;
  width: 200px;
  height: 200px;
  background-color: #fff;
}

.bottom {
  width: 100%;
  height: 200px;
  background-color: #76d3cf;
}

.qr {
  position: fixed;
  top: 100px;
  right: 50px;
  z-index: 10;
  /* width: 200px;  height: 300px; background-color: #F6E9DB;
    border-radius: 10px; */
}

.more {
  margin-bottom: 80px;
  margin-left: calc(50% - 200px);
  width: 400px;
  margin-top: 80px;
  height: 80px;
  font-size: 24px;
  text-align: center;
  line-height: 80px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #000;
  border: 2px solid #0d282c;
  display: flex;
  justify-content: center;
  align-items: center;
}

.more a {
  color: #0d282c;
}

.activeHot {
  background-color: #76d3cf !important;
}

.tabHot {
  width: 220px;
  height: 100px;
  font-size: 28px;
  background-color: #0d282c;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
  text-align: center;
  color: #fff;
  line-height: 100px;
  cursor: pointer;
}

.rightContent {
  width: 880px;
  height: 700px; /* background-color: #7e9ca0; */
}

.hot {
  display: flex;
  width: 1100px;
  height: 700px;
  background-color: #76d3cf;
  margin-left: calc(50% - 550px);
}

.active {
  background-color: #76d3cf !important;
  z-index: 99999;
}

.tabImg {
  margin-top: 50px;
  width: 1100px;
  background-color: #0d282c;
  margin-left: calc(50% - 550px);
}

.tab {
  font-size: 26px;
  width: 400px;
  height: 80px;
  position: relative;
  margin-left: -60px;
  border-radius: 80px;
  background-color: #0d282c;
  text-align: center;
  color: #fff;
  line-height: 80px;
  cursor: pointer;
}

.switch {
  width: 100%;
  margin-left: calc(50% - 340px);
  display: flex;
}

.ant-carousel :deep(.slick-slide) {
  height: 830px;
  line-height: 830px;
  overflow: hidden;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.teamwork {
  background: #0d282c;
  height: 870px;
  padding-top: 90px;
}

.teamwork-more {
  width: 1084px;
  height: 328px;
  margin: 0 auto;
}
.teamwork-more tr {
  display: flex;
  justify-content: space-around;
}
.teamwork-more td {
  width: 353px;
  height: 360px;
  background-color: #76d3cf;
  text-align: center;
  padding-top: 70px;
  position: relative;
  left: 0;
  bottom: -40px;
}

.teamwork-more td .img02 {
  position: relative;
  top: -137px;
  left: 35px;
}
.teamwork-more td .icon {
  width: 130px;
  height: 130px;
  margin-bottom: 15px;
}
.teamwork-more td h4 {
  font-size: 30px;
  font-weight: bold;
}

.teamwork-more td p {
  font-size: 18px;
  font-weight: 540;
  line-height: 10px;
}

.teamwork .table1 {
  display: flex;
  justify-content: center;
  /* width: 1080px; */
  padding-top: 50px; /* margin: 60px auto 0 60px; */
}

.teamwork .table1 td {
  width: 200px;
  position: relative;
}

.teamwork .table1 td img {
  position: relative;
}

.teamwork .table1 p {
  text-align: center;
  color: #f2f2f2;
  line-height: 50px;
  font-size: 20px;
}

.teamwork h3 {
  text-align: center;
  color: #f2f2f2;
  font-size: 20px;
}

.teamwork h2 {
  text-align: center;
  font-size: 58px;
  font-weight: 800;
  color: #76d3cf;
}

.teamwork h2 img {
  padding: 0 30px 0;
}

.design {
  background: #f2f2f2;
  height: 2420px;
  padding-top: 280px;
}

.design h2 {
  text-align: center;
  font-size: 58px;
  font-weight: 800;
}

.design h2 img {
  padding: 0 30px 0;
}

.morelink {
  background: #0d282c;
  height: 700px;
}

.morelink-link {
  margin: 0 auto 30px;
  width: 1170px;
  padding: 51px;
}

.morelink-link h3 {
  text-align: center;
  font-size: 50px;
  color: #76d3cf;
  font-weight: 20;
}

.morelink-link h3 span {
  text-align: center;
  font-size: 54px;
  line-height: 120px;
  color: #76d3cf;
  font-style: italic;
  font-weight: 600;
}

.morelink-link table {
  width: 100%;
  height: 450px;
}

.morelink-link table td {
  text-align: center;
}

.process {
  background: #f2f2f2;
  height: 460px;
  padding-top: 65px;
  padding-bottom: 62px;
}

.process h2 {
  text-align: center;
  font-size: 58px;
  font-weight: 800;
}

.process h2 img {
  padding: 0 30px 0;
}

.process table {
  width: 1050px;
  margin: 50px auto;
}

.process table tr {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
}

.process td {
  width: 235px;
  height: 205px;
  background-color: #76d3cf;
  text-align: center;
  border-radius: 10px;
  margin-left: 10px;
}

.process .td02 {
  background-color: #0d282c;
}

.process td h3 {
  font-size: 30px;
  font-weight: 550;
  color: #f2f2f2;
  line-height: 20px;
}

.process td img {
  position: relative;
  top: -35px;
}

.connect {
  background: #0d282c;
  height: 685px;
  display: flex;
  flex-direction: column;
  /* background: #0d282c url(../image/bg.jpg) no-repeat 65% 100%; */
}

.connect .links_items {
  display: flex;
  justify-content: space-between;
  width: 1170px;
  margin: 0 auto 30px;
  padding: 100px 70px 20px 76px; /* margin: 50px 360px 50px 360px; */
}
.connect .links_items h2 {
  font-size: 34px;
  color: #76d3cf;
  line-height: 40px;
}
.connect .links_items p {
  font-size: 27px;
  color: #f2f2f2;
  margin-top: 20px;
}
.connect .links_items .lefts .items {
  display: flex;
  width: 500px;
  height: 60px;
}

.connect .links_items .rights {
  width: 200px;
  height: 200px;
}
.connectBottom {
  /* position: absolute; left: 10%; bottom: 150px;  margin: 50px 300px 50px 360px;*/
  display: flex;
  justify-content: space-between;
  width: 1170px;
  margin: 0 auto 30px;
  font-size: 20px;
  color: #f2f2f2;
  line-height: 40px;
  padding: 50px 20px 20px 76px;
}
.connectBg {
  /* position: absolute;top: 365px; right: 13%; */
}
.connectBg img {
  width: 360px;
  height: 285px;
  margin-left: 20px;
}
.foot_bar {
  background: #32d6d6;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
}
.foot_bar .icons {
  position: relative;
  left: 150px;
  top: -53px;
}
.foot_bar .icons img {
  width: 45px;
  height: 28px;
}
.foot_bar .titles {
}
.foot_bar .titles .btn {
  background-color: #ffd666;
  font-size: 16px;
  padding: 2px 8px;
  margin: 0 5px;
  border-radius: 5px;
}

.foot_box {
  display: flex;
  flex-direction: column;
  background: #02cacb;
  //height: 300px;
}
.foot_box .foot_link {
  display: flex;
  justify-content: space-between;
  width: 1170px;
  margin: 0 auto;
  padding: 16px 20px 16px 76px; /* padding: 20px 360px 20px 360px; */
}
.foot_link .lefts {
  color: #fff;
  font-size: 10px;
  display: flex;
  flex-direction: column;
}
.foot_link .lefts .title {
  font-size: 13px;
  margin-bottom: 8px;
}
.foot_link .qrcodes {
  display: flex;
}
.foot_link .qrcodes .qr1 {
}
.foot_link .qrcodes img {
  width: 100px;
  height: 100px;
}
.foot_link .qrcodes .qr1 img {
  margin-right: 10px;
}
.foot_link .txt {
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin-top: 10px;
}
.foot_box .copyrights {
  color: #fff;
  font-size: 13px;
  width: 1170px;
  margin: 0 auto;
  padding: 16px 20px 16px 76px; /* padding: 10px 49px 10px 360px; */
  a {
    color: hsla(0,0%,100%,.7);
  }
}
</style>
